import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import { BaseModel, WarehouseModel } from "@insite/client-framework/Types/ApiModels";
import { handleBranchSelectionService } from "@WhiteCap/Services/HandleBranchSelection";

export interface BranchSelectionResultModel extends BaseModel {
    nearestBranch: WarehouseModel
}

export interface BranchSelectionParameter extends ApiParameter {
    latitude: number;
    longitude: number;
}
type HandlerType = ApiHandler<BranchSelectionParameter & HasOnSuccess<BranchSelectionResultModel>, BranchSelectionResultModel>;

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await handleBranchSelectionService(props.parameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.apiResult);
};
export const chain = [
    RequestDataFromApi,
    ExecuteOnSuccessCallback,
];

const handleBranchSelection = createHandlerChainRunner(chain, "HandleBranchSelection");
export default handleBranchSelection;


